/*global VeloxViewController, VeloxWebView, $*/
var uuid = require("uuid") ;

var welcomeController = new VeloxViewController({
    directory : "views/welcome",
    name: "welcome",
    container: "welcome",
    route: "" //displayed by default
}) ;

module.exports = welcomeController ;


welcomeController.on("initView", function(){
    welcomeController.api.api.addOfflineStatusListener(function(isOffline){
        welcomeController.data.offline = isOffline ;
        welcomeController.view.render() ;
    }) ;
}) ;

var langs = [{name: "fr-FR", country: "fr"}, {name: "en-GB", country: "gb"}, {name: "es-ES", country: "es"}, {name: "de-DE", country: "de"}] ;
welcomeController.prepareDataOnEnter = function(data, callback){
    
    if(!this.api.currentUser || this.api.currentUser.login === "anonymous"){
        return callback(null, {factSheets: [], user: this.api.currentUser}) ;
    }

    let deviceType = "web" ;
    if(window.cordova){
        deviceType = "mobile" ;
    }else if(window.native && window.native.spinlab){
        deviceType = "desktop" ;
    }

    //FIXME FOR TEST
    //deviceType = "mobile" ;

    this.api.api.multiread({
        reseller: {searchFirst: {r_code: this.api.currentReseller}},
        reseller_settings: {searchFirst: {r_code: this.api.currentReseller}},
        renewRequests: {table: "reseller_settings", search: {r_renew_status: "WAIT"}, joinFetch: [ {otherTable: "reseller"} ]},
        video: { search : {v_lang: VeloxWebView.i18n.getLang()}, orderBy: "v_name"},
        news: { search : {n_lang: VeloxWebView.i18n.getLang(), n_published: true}, orderBy: "n_date desc"},
        call_to_action: { 
            search : {
                cta_lang: VeloxWebView.i18n.getLang(), 
                cta_device: deviceType,
                cta_date_start: { ope: "<=", value: moment().format("YYYY-MM-DD") },
                cta_date_end: { ope: ">=", value: moment().format("YYYY-MM-DD") }
            }, 
            joinFetch: [
                {otherTable: "call_to_action_trace", type: "2many", name: "traces", joinSearch: {r_code: this.api.currentReseller} },
                { otherTable: "velox_binary", thisField: "cta_id", otherField: "table_uid", name: "binary", joinSearch: {table_name:"call_to_action"}}
            ],
            orderBy: "cta_date_start desc"
        },
        fact_sheet: { search : {f_lang: VeloxWebView.i18n.getLang()}, orderBy: "f_name", joinFetch : [
            { otherTable: "velox_binary", thisField: "f_id", otherField: "table_uid", name: "binary", joinSearch: {table_name:"fact_sheet"}}
        ]}
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var currentLang = VeloxWebView.i18n.getLang() ;
        langs.forEach(function(l){
            l.selected = (l.name.indexOf(currentLang) === 0) ;
        }) ;
        var hasBackup = reads.reseller && reads.reseller.r_nosync && window.native && window.native.pdf && window.native.pdf.genAndPrintReport;

        var renewByLang = {
            "fr-FR": {count: 0, country: "fr", lang: "fr-FR"}, 
            "de-DE": {count: 0, country: "de", lang: "de-DE"}, 
            "en-US": {count: 0, country: "gb", lang: "en-US"}, 
            "es-ES": {count: 0, country: "es", lang: "es-ES"}
        } ;
        reads.renewRequests.forEach(function(r){
            renewByLang[r.reseller.r_lang].count ++ ;
        }) ;

        var renews = Object.keys(renewByLang).sort().map(function(l){ return renewByLang[l] ;}) ;

        var news = reads.news;
        var newsNotSeen = reads.news.filter(function(n){
            return !reads.reseller_settings || !reads.reseller_settings.r_last_news_seen || moment(n.n_date).format("YYYY-MM-DD") > moment(reads.reseller_settings.r_last_news_seen).format("YYYY-MM-DD") ;
        });
        if(this.api.currentUser.profile_code === "SUPER_ADMIN"){
            newsNotSeen = [] ;
        }

        var callToActions = reads.call_to_action;
        var callToActionToShow = callToActions.find(c=>!c.traces.some(t=>t.cta_trace_type === "ignore" || t.cta_trace_type === "open")) ;
        if(this.callToActionClosed || !this.api.currentReseller){
            //already closed don't display again
            callToActionToShow = null;
        }

        welcomeController.updateNewsDateSeen(reads.reseller_settings, newsNotSeen, function(err){
            if(err){
                return callback(err) ;
            }
            welcomeController.updateCallToActionSeen(callToActionToShow, function(err){
                if(err){
                    return callback(err) ;
                }

                if(reads.reseller){
                    this.api.licenseErr = moment(reads.reseller.r_date_end).isBefore(moment()) ;
                    if(!this.api.licenseErr && moment(reads.reseller.r_date_end).isBefore(moment().add(1, "month"))){
                        this.api.licenseWarn = moment(reads.reseller.r_date_end).startOf("day").toDate() ;
                    }else{
                        this.api.licenseWarn = false;
                    }
                }

                var data = {
                    device: process.env.DEVICE,
                    factSheets: reads.fact_sheet.filter(function(s){ return s.binary; }),
                    videos: reads.video,
                    langs: langs,
                    offline: this.api.api.isOffline(),
                    reseller: reads.reseller,
                    reseller_settings: reads.reseller_settings||{},
                    renews: renews,
                    user: this.api.currentUser,
                    hasBackup: hasBackup,
                    news: news,
                    newsNotSeen: newsNotSeen,
                    callToActionToShow: callToActionToShow,
                    licenseErr: this.api.licenseErr,
                    licenseWarn: this.api.licenseWarn,
                }

                if(data.callToActionToShow && data.callToActionToShow.binary && data.callToActionToShow.binary.uid){
                    this.api.readBinary.url(data.callToActionToShow.binary, function(err, url){
                        if(err){ return callback(err) ;}
                        data.callToActionToShow.imageUrl = url ;
                        callback(null, data) ;
                    }) ;
                }else{
                    delete data.callToActionToShow ;
                    callback(null, data) ;
                }

                return callback(null, ) ;
            }.bind(this));
        }.bind(this));
    }.bind(this));
} ;

welcomeController.updateNewsDateSeen = function(reseller_settings, newsNotSeen, callback){
    if(reseller_settings && newsNotSeen.length>0){
        this.api.api.transactionalChanges([
            {
                table: "reseller_settings",
                action: "update",
                record: {
                    r_code: reseller_settings.r_code, 
                    r_last_news_seen: newsNotSeen[0].n_date
                }
            }
        ], callback) ;
    }else{
        callback() ;
    }
}


welcomeController.onCloseCallToAction = function(){
    if(this.data.callToActionToShow){
        this.api.api.transactionalChanges([
            {
                table: "call_to_action_trace",
                action: "insert",
                record: {
                    cta_trace_id: uuid.v4(),
                    r_code: this.api.currentReseller, 
                    cta_id: this.data.callToActionToShow.cta_id,
                    cta_trace_type: "close",
                    cta_trace_date: new Date()
                }
            }
        ], err=>{
            if(err){ console.log("Error closing call to action", err) ;}
        }) ;

        this.data.callToActionToShow = null;
        this.callToActionClosed = true ;
        this.view.render() ;
    }
}

welcomeController.onIgnoreCallToAction = function(){
    if(this.data.callToActionToShow){
        this.api.api.transactionalChanges([
            {
                table: "call_to_action_trace",
                action: "insert",
                record: {
                    cta_trace_id: uuid.v4(),
                    r_code: this.api.currentReseller, 
                    cta_id: this.data.callToActionToShow.cta_id,
                    cta_trace_type: "ignore",
                    cta_trace_date: new Date()
                }
            }
        ], err=>{
            if(err){ console.log("Error closing call to action", err) ;}
        }) ;

        this.data.callToActionToShow = null;
        this.callToActionClosed = true ;
        this.view.render() ;
    }
}

welcomeController.onOpenCallToAction = function(){
    if(this.data.callToActionToShow){
        this.api.api.transactionalChanges([
            {
                table: "call_to_action_trace",
                action: "insert",
                record: {
                    cta_trace_id: uuid.v4(),
                    r_code: this.api.currentReseller, 
                    cta_id: this.data.callToActionToShow.cta_id,
                    cta_trace_type: "open",
                    cta_trace_date: new Date()
                }
            }
        ], err=>{
            if(err){ return console.log("Error closing call to action", err) ;}
            if(window.native && window.native.openLink){
                window.native.openLink.openInBrowser({url : this.data.callToActionToShow.cta_url}, function(){ console.log("link call to action open") ; }) ;
            }else{
                window.open(this.data.callToActionToShow.cta_url) ;
            }
            this.data.callToActionToShow = null;
            this.callToActionClosed = true ;
            this.view.render() ;
        }) ;

    }
}

welcomeController.updateCallToActionSeen = function(callToActionToShow, callback){
    if(callToActionToShow){
        this.api.api.transactionalChanges([
            {
                table: "call_to_action_trace",
                action: "insert",
                record: {
                    cta_trace_id: uuid.v4(),
                    r_code: this.api.currentReseller, 
                    cta_id: callToActionToShow.cta_id,
                    cta_trace_type: "view",
                    cta_trace_date: new Date()
                }
            }
        ], callback) ;
    }else{
        callback() ;
    }
}


welcomeController.onAuthenticationExtrabatRedo = function(){
    this.view.longTask(function(done){
        this.api.extrabat.getAuthUrl(this.data.reseller_settings.r_code, function(err, url){
            if(err){ return done(err) ; }
            done();
            this.view.info(this.view.tr("reseller.validateAccessInOpenedWindow"), function(){
                var child = window.open(url) ;
                var timer;
                timer = setInterval(function () {
                    if (child.closed) {
                        this.refresh() ;    
                        clearInterval(timer);
                    }
                }.bind(this), 200);
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
}



welcomeController.onLang = function(ev){
    var lang = ev.data.data.name ;
    this.view.longTask(function(done){
        this.api.api.velox_user.update({uid: this.api.currentUser.uid, lang: lang}, function(err){
            if(err){ return done(err) ;}

            VeloxWebView.i18n.setLang(lang) ;
            this.refresh() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

welcomeController.onSearch = function(ev){
    var inputSearch = ev.data ;
    this.navigate("~customer/list", {s:inputSearch}) ;
} ;


welcomeController.onFactSheet = function(ev){
    var factSheet = ev.data.data ;
    this.view.longTask(function(done){
        this.api.readBinary.download(factSheet.binary, factSheet.f_name+".pdf", done) ;
    }.bind(this));
} ;

welcomeController.onVideo = function(ev){
    var video = ev.data.data ;
    var viewEmail = new VeloxWebView("views/video", "popupVideo", {bindObject: video}) ;
    viewEmail.openInPopup({
        size:"wide",
        title: " "
    })  ;
} ;


welcomeController.onNewCustomer = welcomeController.onNewCustomer2 = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    this.navigate("/customer/form") ;
} ;
welcomeController.onNewDiag = welcomeController.onNewDiag2 = function(){
    if(this.api.licenseErr){
        return VeloxWebView.error(VeloxWebView.tr("mustHaveLicense")) ;
    }
    this.navigate("/diag/form") ;
} ;

welcomeController.onLogout = function(){
    this.view.longTask(function(done){
        this.api.logout(function(err){
            if(err){ return done(err);}
            this.navigate("/") ;
            window.location.reload() ;
            done() ;
        }.bind(this)) ;
    }.bind(this));
} ;


welcomeController.onRenewLicenseErr = welcomeController.onRenewLicense = function(){

    var viewRenew = new VeloxWebView("views/welcome", "popupRenew") ;
    viewRenew.openInPopup({
        size:"medium",
        title: " "
    })  ;
    viewRenew.on("renew",function(){
        viewRenew.checkForm(viewRenew.EL.formRenew, [],function(err, checkOk){
            if(err){ return viewRenew.error(err) ;}
            if(!checkOk){
                return;
            }
            var message = viewRenew.getData().r_renew_message ;
            this.view.longTask(function(done){
                this.api.api.transactionalChangesNoCache([ //use no cache to force no sync reseller to save on server
                    {
                        table: "reseller_settings",
                        record: {
                            r_code: this.api.currentReseller, 
                            r_renew_status: 'WAIT', 
                            r_renew_date: new Date(),
                            r_renew_message: message
                        }
                    }
                ], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.api.api.multiread({
                        reseller_settings: {searchFirst: {r_code: this.api.currentReseller}},
                    }, function(err, reads){
                        if(err){ return done(err) ;}
                        if(reads.reseller_settings && reads.reseller_settings.r_renew_status === 'ACCEPT'){
                            VeloxWebView.info(VeloxWebView.tr("welcome.licenseRenewAccepted"), function(){
                                this.view.longTask(function(done){
                                    this.api.api.transactionalChangesNoCache([
                                        {
                                            table: "reseller_settings",
                                            record: {
                                                r_code: this.api.currentReseller, 
                                                r_renew_status: 'ACC_DONE', 
                                            }
                                        }
                                    ], function(err){
                                        if(err){ return done(err) ;}
                                        done() ;
                                        this.refresh() ;
                                        viewRenew.close() ;
                                    }.bind(this)) ;
                                }.bind(this)) ;
                            }.bind(this)) ;
                        }else{
                            this.view.info(VeloxWebView.tr("welcome.renewSaved"), function(){
                                this.refresh() ;
                                viewRenew.close() ;
                            }.bind(this)) ;
                        }
                    }.bind(this)) ; 
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this));
    }.bind(this)) ;
} ;

welcomeController.onDisplayed = function(ev){
    //check WLC version on startup
    if(window.native && window.native.spinlab){
        window.native.spinlab.checkWlc(function(err){
            if(err){
                var message = err;
                if(err === "MISSING_WLC"){
                    message = VeloxWebView.tr("diag.shouldInstallWlc") ;
                } else if(err === "SHOULD_UPDATE_WLC"){
                    message = VeloxWebView.tr("diag.shouldUpdateWlc") ;
                }
                return this.view.error(message, function(){
                    window.native.spinlab.install() ;
                }) ;
            }
        }.bind(this)) ;
    }
    if(this.data && this.data.reseller_settings && this.data.reseller_settings.r_renew_status === 'ACCEPT'){
        VeloxWebView.info(VeloxWebView.tr("welcome.licenseRenewAccepted"), function(){
            this.view.longTask(function(done){
                this.api.api.transactionalChangesNoCache([
                    {
                        table: "reseller_settings",
                        record: {
                            r_code: this.api.currentReseller, 
                            r_renew_status: 'ACC_DONE', 
                        }
                    }
                ], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.refresh() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    } else if(this.data && this.data.reseller_settings && this.data.reseller_settings.r_renew_status === 'REFUSED'){
        VeloxWebView.error(VeloxWebView.tr("welcome.licenseRenewRefused"), function(){
            this.view.longTask(function(done){
                this.api.api.transactionalChangesNoCache([
                    {
                        table: "reseller_settings",
                        record: {
                            r_code: this.api.currentReseller, 
                            r_renew_status: 'REF_DONE', 
                        }
                    }
                ], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.refresh() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    } 
} ;

welcomeController.onChangePassword = function(){
    this.view.longTask(function(done){
        var viewChange = new VeloxWebView("views/main", "changePassword") ;
        viewChange.openInPopup({
            title: VeloxWebView.tr("main.changePassword")
        }, function(){
            done() ;
        }.bind(this))  ;
        viewChange.on("cancel",function(ev){
            viewChange.close() ;
        });
        viewChange.on("validate",function(ev){
            var data = viewChange.getData() ;
            this.api.changeUserPassword(data.passwordOld, data.passwordNew, function(err, success){
                if(err){ return done(err);}
                if(!success){
                    return done(VeloxWebView.tr("main.wrongPassword")) ;
                }
                viewChange.close() ;
                VeloxWebView.info(VeloxWebView.tr("main.changePasswordSuccess"), done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

welcomeController.onRenewRequest = function(ev){
    var lang = ev.data.data.lang ;
    this.navigate("renew", lang) ;
} ;

welcomeController.on("initView", function(){
    welcomeController.appController.on("routeChanged", function(ev){
        if(ev.data.removedRoutes.length > 0 && ev.data.removedRoutes[0].route === "renew"){
            welcomeController.refresh() ;
        }
    }) ;
}) ;

welcomeController.on("stack", function(){
    var notifs = document.querySelectorAll('[data-notify="container"]') ;
    for(var i=0; i<notifs.length; i++){
        notifs[i].parentElement.removeChild(notifs[i]) ;
    }
}) ;